/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Dl_Trouble_Logs_QInputs */

const en_wc_dl_trouble_logs_q = /** @type {(inputs: Wc_Dl_Trouble_Logs_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where are the logs for a bug report?`)
};

/**
* | output |
* | --- |
* | "Where are the logs for a bug report?" |
*
* @param {Wc_Dl_Trouble_Logs_QInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_dl_trouble_logs_q = /** @type {((inputs?: Wc_Dl_Trouble_Logs_QInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Dl_Trouble_Logs_QInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_dl_trouble_logs_q(inputs)
});
export { wc_dl_trouble_logs_q as "wc.dl.trouble.logs.q" }